import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tr-not-found',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './not-found.component.html',
  //styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/not-found/not-found.component.ts